var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _metadata;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    id: "svg1106",
    viewBox: "0 0 464.05 970.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1108"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1257"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1258",
    stopColor: "#ff0a31",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop1259",
    stopColor: "#c60200",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1253"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1254",
    stopColor: "#6b5635",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop1255",
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient2569",
    fx: 208.68,
    fy: 107.57,
    xlinkHref: "#linearGradient1253",
    gradientUnits: "userSpaceOnUse",
    cy: 106.33,
    cx: 209.53,
    gradientTransform: "matrix(.98293 0 0 1.0174 -141.49 -36.096)",
    r: 88.778
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient2572",
    fx: 538.56,
    fy: 113.43,
    xlinkHref: "#linearGradient1253",
    gradientUnits: "userSpaceOnUse",
    cy: 113.83,
    cx: 537.79,
    gradientTransform: "matrix(1.0195 0 0 .98091 -141.49 -36.096)",
    r: 110.57
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2575",
    y2: 313.28,
    xlinkHref: "#linearGradient1257",
    gradientUnits: "userSpaceOnUse",
    x2: 193.83,
    gradientTransform: "matrix(.90597 0 0 1.1038 -141.49 -36.096)",
    y1: 313.28,
    x1: 156.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2578",
    y2: 310.08,
    xlinkHref: "#linearGradient1257",
    gradientUnits: "userSpaceOnUse",
    x2: 681,
    gradientTransform: "matrix(.88920 0 0 1.1246 -141.49 -36.096)",
    y1: 310.08,
    x1: 643.23
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient2584",
    xlinkHref: "#linearGradient1257",
    gradientUnits: "userSpaceOnUse",
    cy: 346.26,
    cx: 565.16,
    gradientTransform: "matrix(.66292 0 0 1.5085 -141.49 -36.096)",
    r: 420.99
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1228",
    d: "m231.35 2.0918c175.61 6.1579 228.86 30.31 209.41 288.39-3.05 7.13-6.11 14.26-9.16 21.38 3.6 119.1 7.2 238.92 0 357.29 11.69 12.77 6.11 29.86 9.16 44.79 5 38.45 7.12 92.73 2.04 145.57-8.5 118.7-132.17 107.84-202.57 109.93-78.45-1.75-184.26 23.84-213.76-108.92-2.884-61.2-3.604-110.16-0.005-177.12 2.714-5.09 5.429-10.17 8.143-15.26-3.277-117.65-7.274-233.14-1.194-357.26-3.599-9.84-7.198-19.68-10.797-29.51-13.196-254.33 36.949-270.4 208.73-279.28z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.75,
    fill: "url(#radialGradient2584)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1234",
    d: "m431.6 98.096c-37.32-74.309-122.49-83.47-203.59-85.506-86.18 3.733-154.04 5.429-197.47 96.7 11.872-34.606 0.336-104.84 198.49-108.92 179.84 3.3981 190.69 51.58 202.57 97.726z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.75,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1229",
    d: "m62.092 234.5c80.418-91.28 260.59-99.08 338.97 1.02-5.43 47.5-10.86 95-16.28 142.51-73.97-16.63-190.7-34.27-304.36 5.09-6.113-49.54-12.22-99.08-18.328-148.62z",
    fillRule: "evenodd",
    fillOpacity: 0.83065,
    stroke: "#000",
    strokeWidth: "1pt"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1230",
    d: "m93.648 706.82c99.082 10.52 191.03 16.96 278.91-5.09v145.56c-87.2 58.02-192.73 54.97-276.88 3.05-0.675-47.84-1.353-95.68-2.032-143.52z",
    fillRule: "evenodd",
    fillOpacity: 0.83065,
    stroke: "#000",
    strokeWidth: "1pt"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1232",
    d: "m440.25 292.01c23.24 10.69 27.15 35.63 19.85 41.23-8.14-0.85-20.36-12.39-28.5-14.25-0.17-2.38-0.34-4.75-0.51-7.13 3.39-6.45 5.77-13.4 9.16-19.85z",
    fillRule: "evenodd",
    fillOpacity: 0.75,
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#linearGradient2578)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path1233",
    d: "m25.21 289.54c-23.691 9.66-28.686 34.4-21.645 40.31 8.173-0.49 20.884-11.47 29.102-12.98 0.274-2.37 0.548-4.73 0.822-7.1-3.106-6.59-5.173-13.64-8.279-20.23z",
    fillRule: "evenodd",
    fillOpacity: 0.75,
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#linearGradient2575)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path1235",
    d: "m381.72 45.164c-24.94 6.107-20.87 19.34 3.06 39.699 19.51 14.081 31.38 16.457 32.57-5.09-1.7-12.554-30.37-33.252-35.63-34.609z",
    fillOpacity: 0.75,
    fill: "url(#radialGradient2572)",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path1236",
    d: "m83.154 44.172c25.346 4.076 22.356 17.594 0.157 39.816-18.311 15.608-29.957 18.932-32.878-2.447 0.679-12.65 27.588-35.593 32.721-37.369z",
    fillRule: "evenodd",
    fillOpacity: 0.75,
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#radialGradient2569)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path1237",
    d: "m49.877 270.13c-9.161 147.26-7.125 283.32-2.036 425.49 4.072 25.11 7.126 51.24 11.197 76.34 12.385-61.92 20.189-192.55 14.251-315.55-5.259-66.17-13.572-123.68-23.412-186.28z",
    fillRule: "evenodd",
    fillOpacity: 0.83065,
    stroke: "#000",
    strokeWidth: "1pt"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path1238",
    d: "m417.24 258.62c9.16 147.26 7.13 283.32 2.04 425.49-4.08 25.11-7.13 51.24-11.2 76.35-12.39-61.93-20.19-192.56-14.25-315.56 5.26-66.16 13.57-123.68 23.41-186.28z",
    fillRule: "evenodd",
    fillOpacity: 0.83065,
    stroke: "#000",
    strokeWidth: "1pt"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path1239",
    d: "m193.21 897.5l82.77-0.72-2.16 8.64-76.3 0.72-4.31-8.64z",
    fillRule: "evenodd",
    fillOpacity: 0.58065,
    stroke: "#000",
    strokeWidth: "1pt"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path1241",
    d: "m395.16 965.63a16.915 8.9973 0 1 1 -33.83 0 16.915 8.9973 0 1 1 33.83 0z",
    fillRule: "evenodd",
    transform: "translate(-142.93 -44.013)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#29007d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path1242",
    d: "m354.44 918.38c5.52-10.08 49.18-28.08 57.58-21.6 6 18-25.43 36.71-38.15 41.03-10.8 0-20.15-8.64-19.43-19.43z",
    fillRule: "evenodd",
    fillOpacity: 0.71774,
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#f00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path1243",
    d: "m118 920.24c-5.52-10.08-49.183-28.07-57.58-21.59-5.999 17.99 25.432 36.71 38.148 41.02 10.792 0 20.152-8.63 19.432-19.43z",
    fillRule: "evenodd",
    fillOpacity: 0.71774,
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#f00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path1244",
    d: "m382.51 380.7c-11.52 107.97-12.24 214.49-10.8 316.7",
    strokeOpacity: 0.64516,
    stroke: "#000",
    strokeWidth: 3.5,
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path1245",
    d: "m80.92 384.3c9.837 117.8 13.196 217.61 13.676 318.86",
    strokeOpacity: 0.66129,
    stroke: "#000",
    strokeWidth: 2.75,
    fill: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path1250",
    d: "m222.3 686.63c-0.46-1.01 0.24 2.22 0.44 3.31 0.4 2.18 0.89 4.33 1.44 6.47 1.64 6.36 3.81 12.52 6.14 18.64 0.57 1.44 1.15 2.88 1.73 4.31l-0.83 0.16c-0.6-1.44-1.2-2.87-1.79-4.3-3.68-9.03-8.73-18.93-10.62-28.59h3.49z",
    fillOpacity: 0.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path1251",
    d: "m169.45 937.09c-0.36 5.64-2.16 10.56-4.32 15.84 47.63 2.63 99.21 3.11 148.28-2.88-3-3.84-4.92-9.12-5.76-15.84-43.91 4.56-91.41 4.8-138.2 2.88z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#e1bd23"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path1271",
    d: "m393.72 74.536a18.714 11.157 0 1 1 -37.43 0 18.714 11.157 0 1 1 37.43 0z",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 .86614 -142.6 -33.28)",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#0a007d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "text1272",
    d: "m165.31-48.445h1.86l1.35 11.427 1.6-7.561h1.99l1.62 7.58 1.35-11.446h1.86l-2.11 14.077h-1.8l-1.91-8.363-1.9 8.363h-1.81l-2.1-14.077z",
    fill: "#fff",
    transform: "scale(1.354 -.73854)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path1276",
    d: "m61.583 229.32c6.108-136.88 64.127-201.57 169.49-208.52 130.97 3.917 162.19 87.5 169.99 209.06",
    strokeOpacity: 0.46774,
    stroke: "#000",
    strokeWidth: 2.4343,
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "text1278",
    d: "m150.49 1269.6v0.9h-5.05c0-0.2 0.03-0.4 0.11-0.7 0.13-0.3 0.34-0.6 0.62-1 0.28-0.3 0.69-0.7 1.23-1.1 0.83-0.7 1.39-1.2 1.68-1.6s0.43-0.8 0.43-1.2c0-0.3-0.13-0.7-0.39-0.9-0.27-0.3-0.62-0.4-1.04-0.4-0.45 0-0.81 0.1-1.08 0.4-0.28 0.3-0.41 0.7-0.42 1.1l-0.96-0.1c0.07-0.7 0.32-1.2 0.75-1.6s1-0.6 1.73-0.6 1.31 0.2 1.74 0.6c0.42 0.5 0.64 1 0.64 1.6 0 0.3-0.07 0.6-0.19 0.9-0.13 0.3-0.33 0.6-0.62 0.9s-0.77 0.8-1.45 1.3c-0.56 0.5-0.92 0.8-1.08 1s-0.29 0.3-0.39 0.5h3.74zm1.15-0.9l0.9-0.1c0.07 0.5 0.22 0.8 0.44 1 0.21 0.2 0.49 0.3 0.82 0.3 0.29 0 0.54-0.1 0.76-0.2 0.22-0.2 0.39-0.3 0.53-0.6 0.14-0.2 0.26-0.5 0.35-0.9 0.1-0.3 0.14-0.7 0.14-1.1v-0.2c-0.19 0.3-0.45 0.5-0.77 0.7s-0.68 0.3-1.05 0.3c-0.64 0-1.17-0.2-1.61-0.7-0.43-0.4-0.65-1-0.65-1.8s0.23-1.4 0.68-1.9c0.46-0.4 1.03-0.7 1.72-0.7 0.49 0 0.95 0.2 1.36 0.4 0.41 0.3 0.72 0.7 0.93 1.2 0.22 0.5 0.32 1.2 0.32 2.1 0 1-0.1 1.8-0.31 2.4-0.22 0.5-0.53 1-0.95 1.3s-0.91 0.4-1.47 0.4c-0.6 0-1.08-0.1-1.46-0.5-0.38-0.3-0.61-0.8-0.68-1.4zm3.83-3.3c0-0.6-0.14-1-0.43-1.3-0.28-0.3-0.63-0.5-1.03-0.5-0.42 0-0.78 0.2-1.09 0.5-0.31 0.4-0.46 0.8-0.46 1.3s0.15 0.9 0.44 1.2 0.65 0.5 1.08 0.5c0.44 0 0.79-0.2 1.07-0.5s0.42-0.7 0.42-1.2zm1.97 3.1l0.93-0.1c0.11 0.5 0.29 0.9 0.55 1.1s0.57 0.4 0.95 0.4c0.44 0 0.81-0.2 1.11-0.5 0.31-0.3 0.46-0.7 0.46-1.1 0-0.5-0.14-0.8-0.42-1.1-0.29-0.3-0.64-0.4-1.08-0.4-0.17 0-0.39 0-0.66 0.1l0.11-0.8h0.15c0.4 0 0.76-0.1 1.07-0.3 0.32-0.2 0.48-0.6 0.48-1 0-0.3-0.11-0.6-0.35-0.9-0.23-0.2-0.53-0.3-0.9-0.3-0.36 0-0.66 0.1-0.91 0.4-0.24 0.2-0.4 0.5-0.46 1l-0.94-0.2c0.11-0.6 0.37-1.1 0.78-1.4 0.41-0.4 0.91-0.6 1.51-0.6 0.42 0 0.8 0.1 1.15 0.3s0.62 0.4 0.81 0.7c0.18 0.3 0.28 0.7 0.28 1s-0.09 0.6-0.27 0.9-0.44 0.5-0.78 0.7c0.45 0.1 0.8 0.3 1.05 0.6s0.37 0.8 0.37 1.2c0 0.7-0.24 1.3-0.73 1.7-0.48 0.5-1.1 0.7-1.84 0.7-0.67 0-1.23-0.2-1.67-0.6s-0.69-0.9-0.75-1.5zm6.06 0.2l0.9-0.1c0.08 0.5 0.23 0.8 0.44 1 0.22 0.2 0.49 0.3 0.83 0.3 0.29 0 0.54-0.1 0.76-0.2 0.21-0.2 0.39-0.3 0.53-0.6 0.14-0.2 0.25-0.5 0.35-0.9 0.09-0.3 0.14-0.7 0.14-1.1 0 0 0-0.1-0.01-0.2-0.18 0.3-0.44 0.5-0.76 0.7-0.33 0.2-0.68 0.3-1.06 0.3-0.63 0-1.16-0.2-1.6-0.7-0.44-0.4-0.66-1-0.66-1.8s0.23-1.4 0.69-1.9c0.45-0.4 1.02-0.7 1.71-0.7 0.5 0 0.95 0.2 1.36 0.4 0.41 0.3 0.73 0.7 0.94 1.2s0.32 1.2 0.32 2.1c0 1-0.11 1.8-0.32 2.4-0.21 0.5-0.52 1-0.94 1.3s-0.91 0.4-1.47 0.4c-0.6 0-1.09-0.1-1.46-0.5-0.38-0.3-0.61-0.8-0.69-1.4zm3.84-3.3c0-0.6-0.14-1-0.43-1.3s-0.63-0.5-1.03-0.5c-0.42 0-0.78 0.2-1.09 0.5-0.31 0.4-0.46 0.8-0.46 1.3s0.14 0.9 0.44 1.2c0.29 0.3 0.65 0.5 1.08 0.5s0.79-0.2 1.07-0.5 0.42-0.7 0.42-1.2zm1.96 3.1l0.94-0.1c0.11 0.5 0.29 0.9 0.55 1.1s0.57 0.4 0.94 0.4c0.44 0 0.81-0.2 1.12-0.5 0.3-0.3 0.45-0.7 0.45-1.1 0-0.5-0.14-0.8-0.42-1.1s-0.64-0.4-1.07-0.4c-0.18 0-0.4 0-0.66 0.1l0.1-0.8h0.15c0.4 0 0.76-0.1 1.08-0.3s0.48-0.6 0.48-1c0-0.3-0.12-0.6-0.35-0.9-0.23-0.2-0.53-0.3-0.9-0.3-0.36 0-0.67 0.1-0.91 0.4-0.24 0.2-0.4 0.5-0.47 1l-0.94-0.2c0.12-0.6 0.38-1.1 0.79-1.4 0.4-0.4 0.91-0.6 1.51-0.6 0.42 0 0.8 0.1 1.15 0.3s0.62 0.4 0.8 0.7c0.19 0.3 0.28 0.7 0.28 1s-0.09 0.6-0.26 0.9c-0.18 0.3-0.44 0.5-0.79 0.7 0.45 0.1 0.8 0.3 1.05 0.6s0.38 0.8 0.38 1.2c0 0.7-0.25 1.3-0.73 1.7-0.49 0.5-1.1 0.7-1.84 0.7-0.67 0-1.23-0.2-1.67-0.6s-0.7-0.9-0.76-1.5zm8.43 2l2.93-7.6h1.08l3.13 7.6h-1.15l-0.89-2.3h-3.19l-0.84 2.3h-1.07zm2.2-3.1h2.58l-0.79-2.1c-0.24-0.7-0.43-1.2-0.54-1.6-0.1 0.5-0.24 0.9-0.41 1.4l-0.84 2.3zm5.71 3.1v-7.6h2.86c0.59 0 1.06 0 1.41 0.2s0.63 0.4 0.82 0.7c0.2 0.3 0.3 0.7 0.3 1s-0.08 0.7-0.26 0.9c-0.18 0.3-0.45 0.6-0.8 0.7 0.46 0.2 0.81 0.4 1.06 0.7 0.25 0.4 0.37 0.7 0.37 1.2 0 0.3-0.07 0.7-0.22 1s-0.34 0.5-0.56 0.7-0.5 0.3-0.84 0.4c-0.33 0.1-0.74 0.1-1.23 0.1h-2.91zm1.01-4.4h1.65c0.45 0 0.77-0.1 0.96-0.1 0.26-0.1 0.45-0.2 0.58-0.4s0.2-0.4 0.2-0.7c0-0.2-0.06-0.4-0.18-0.6s-0.3-0.4-0.52-0.4c-0.23-0.1-0.62-0.1-1.16-0.1h-1.53v2.3zm0 3.5h2.59c0.23-0.1 0.43-0.2 0.58-0.2 0.16-0.1 0.29-0.3 0.39-0.5s0.15-0.4 0.15-0.6c0-0.3-0.08-0.5-0.22-0.8-0.15-0.2-0.35-0.3-0.61-0.4s-0.63-0.1-1.11-0.1h-1.77v2.6zm13.59-4.9l-0.93 0.1c-0.08-0.4-0.2-0.6-0.36-0.8-0.25-0.3-0.56-0.4-0.93-0.4-0.3 0-0.56 0.1-0.79 0.3-0.29 0.2-0.53 0.5-0.7 0.9s-0.25 1-0.26 1.8c0.22-0.4 0.5-0.6 0.83-0.8 0.32-0.2 0.66-0.3 1.02-0.3 0.63 0 1.16 0.3 1.6 0.7 0.44 0.5 0.66 1.1 0.66 1.8 0 0.5-0.11 0.9-0.31 1.4-0.21 0.4-0.49 0.7-0.85 0.9-0.37 0.2-0.78 0.3-1.23 0.3-0.78 0-1.42-0.3-1.91-0.8-0.5-0.6-0.74-1.6-0.74-2.9 0-1.4 0.27-2.5 0.81-3.2 0.48-0.6 1.12-0.9 1.93-0.9 0.6 0 1.09 0.2 1.47 0.5 0.38 0.4 0.61 0.8 0.69 1.4zm-3.82 3.3c0 0.3 0.06 0.7 0.2 1 0.14 0.2 0.33 0.5 0.58 0.6 0.24 0.2 0.5 0.3 0.77 0.3 0.4 0 0.74-0.2 1.02-0.5 0.29-0.3 0.43-0.8 0.43-1.3s-0.14-1-0.42-1.3-0.64-0.4-1.07-0.4c-0.42 0-0.78 0.1-1.07 0.4-0.3 0.3-0.44 0.7-0.44 1.2zm9.82 1.6v0.9h-5.05c0-0.2 0.03-0.4 0.11-0.7 0.13-0.3 0.34-0.6 0.62-1 0.28-0.3 0.69-0.7 1.22-1.1 0.83-0.7 1.39-1.2 1.69-1.6 0.29-0.4 0.43-0.8 0.43-1.2 0-0.3-0.13-0.7-0.4-0.9-0.26-0.3-0.61-0.4-1.03-0.4-0.46 0-0.82 0.1-1.09 0.4s-0.4 0.7-0.41 1.1l-0.96-0.1c0.07-0.7 0.31-1.2 0.74-1.6s1.01-0.6 1.74-0.6 1.31 0.2 1.74 0.6c0.42 0.5 0.64 1 0.64 1.6 0 0.3-0.07 0.6-0.19 0.9-0.13 0.3-0.33 0.6-0.62 0.9s-0.78 0.8-1.45 1.3c-0.56 0.5-0.92 0.8-1.08 1s-0.29 0.3-0.4 0.5h3.75z",
    transform: "scale(1.3386 .74706)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path1281",
    d: "m406.98 762.9c-4.8 112.29-68.62 181.39-169.87 172.75-86.85 2.88-169.39-50.38-178.5-159.79",
    strokeOpacity: 0.52419,
    stroke: "#000",
    strokeWidth: 1.625,
    fill: "none"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", null, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("ccLicense", {
    rdfResource: "http://creativecommons.org/licenses/publicdomain/"
  }), /*#__PURE__*/React.createElement("dcPublisher", null, /*#__PURE__*/React.createElement("ccAgent", {
    rdfAbout: "http://openclipart.org/"
  }, /*#__PURE__*/React.createElement("dcTitle", null, "Openclipart")))), /*#__PURE__*/React.createElement("ccLicense", {
    rdfAbout: "http://creativecommons.org/licenses/publicdomain/"
  }, /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#Reproduction"
  }), /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#Distribution"
  }), /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#DerivativeWorks"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.d1243a646be834529b268b6d9d457f4a.svg";
export { ForwardRef as ReactComponent };